import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'adm-comment',
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss',
  imports: [MatDialogModule, MatIconModule],
})
export class CommentComponent {
  dialogRef = inject<MatDialogRef<CommentComponent>>(MatDialogRef);
  data = inject<{
    comment: string;
  }>(MAT_DIALOG_DATA);
}
